import { useFormStore } from "@modules/formx-react/useFormStore";
import { store } from "@store";
import { useSetCustomerRecommendedPricesMutation } from "@graphql";
import { useSnackbars } from "@hooks";

type Item = {
  profession: string;
  areaOfExpertise: string;
  value: string;
};

export type FormData = {
  items: Item[];
};

export function useForm(customerId: string) {
  const [update] = useSetCustomerRecommendedPricesMutation();
  const { showSuccess, showError } = useSnackbars();

  const form = useFormStore<FormData>({
    initialValues: { items: getInitialValues() },
    onSubmit: () => {
      return update({
        variables: {
          customerId,
          input: form.values.items.filter((x) => x.value)
        }
      })
        .then((res) => {
          showSuccess("Sparat");
          form.reset({
            items: getInitialValues(
              res.data.setCustomerRecommendedPrices.recommendedPrices
            )
          });
        })
        .catch((err) => {
          showError(`Cannot save\nError: ${err}`);
        });
    }
  });

  const getItemIndex = (profession: string, areaOfExpertise: string) =>
    form.values.items.findIndex(
      (x) => x.profession === profession && x.areaOfExpertise === areaOfExpertise
    );

  const reset = (initialItems: Item[]) =>
    form.reset({ items: getInitialValues(initialItems) });

  return { form, getItemIndex, reset };
}

function getInitialValues(initialItems: Item[] = []) {
  const items: Array<{
    profession: string;
    areaOfExpertise: string;
    value: string;
  }> = [];

  store()
    .cache.professions.sortBy((x) => x)
    .forEach((profession) => {
      store()
        .cache.getAreaOfExpOnProfessions([profession])
        .forEach((areaOfExpertise) => {
          const initialValue =
            initialItems.find(
              (x) =>
                x.profession === profession && x.areaOfExpertise === areaOfExpertise.Name
            )?.value ?? "";

          items.push({
            profession,
            areaOfExpertise: areaOfExpertise.Name,
            value: initialValue
          });
        });
    });

  return items;
}
